import { EntityWithStatusService } from './EntityWithStatusService';
import { IEntityChildren, IEntityDescription1, IRiskAppIncident } from '../types';
import { EntityStatus } from '../refData/EntityStatus';
import { AppGlobals } from '../AppGlobals';

export class RiskAppIncidentService extends EntityWithStatusService<IRiskAppIncident> {
    public readonly parentEntities = ['ManagedByL2', 'ManagedByL3'];
    protected childrenEntities = ['RiskAppIncidentIssues', 'RiskAppIncidentSystems', 'RiskAppIncidentStakeholders', 'RiskAppIncidentImpactTypes', 'Contributors($expand=ContributorUser)', 'CustomFields($expand=CustomFieldDfn)'];

    constructor() {
        super(`/RiskAppIncidents`);
    }

    public readAllForLookup(includeClosed?: boolean): Promise<IRiskAppIncident[]> {
        return this.readAll(
            `?$select=ID,Title`
            + `&$orderby=Title&$filter=CustomerID eq ${AppGlobals.CustomerID}`
            + (includeClosed ? `` : ` and EntityStatusID eq ${EntityStatus.Open}`)
        );
    }

    public readAllForList(includeClosed?: boolean): Promise<IRiskAppIncident[]> {
        return this.readAll(
            `?$select=ID,Title,OwnerTypeID,ManagedByTypeID,DateReported,TargetResolutionDate`
            + `&$orderby=Title`
            + `&$expand=Location($select=Title),RiskAppIncidentSystems($expand=System($select=Title)),Severity($select=Title),IncidentType($select=Title),Stage($select=Title),OwnerL1($select=Title),OwnerL2($select=Title),OwnerL3($select=Title),ManagedByL2($select=Title),ManagedByL3($select=Title),EntityStatus($select=Title),IncidentManager($select=Title),Contributors($expand=ContributorUser($select=Title)),RiskAppIncidentActions($select=ID)`
            + `&$filter=CustomerID eq ${AppGlobals.CustomerID}`
            + (includeClosed ? `` : ` and EntityStatusID eq ${EntityStatus.Open}`)
        );
    }

    public async readTitleForCorrectiveActions(entityPlural: string, entitySingular: string, incidentID: number): Promise<IEntityDescription1> {
        const entityDescription1: IEntityDescription1 = {
            DescriptionLine1: '',
            DescriptionLine2: '',
            Description1ForList: '',
            Description1ForForm: ''
        };
        const res = await this.readAll(`?$filter=ID eq ${incidentID}&$select=Title`);
        if (res.length > 0) {
            entityDescription1.DescriptionLine1 = `${entityPlural} for incident`;
            entityDescription1.DescriptionLine2 = res[0].Title;
            entityDescription1.Description1ForList = `${entityPlural} for incident <span style='font-style: italic'>${res[0].Title}</span>`;
            entityDescription1.Description1ForForm = `${entitySingular} for incident <span style='font-style: italic'>${res[0].Title}</span>`;
        }

        return entityDescription1;
    }

    public async entityChildren(id: number): Promise<IEntityChildren[]> {
        const entityUrl = `${this.entityUrl}(${id})`;
        const actions = (await this.axiosGet(`${entityUrl}/RiskAppIncidentActions?$select=ID&$top=10`)).data.value;
        const evidences = (await this.axiosGet(`${entityUrl}/RiskAppEvidences?$select=ID&$top=10`)).data.value;
        return [
            { ChildType: 'Corrective Actions', CanBeAdopted: false, ChildIDs: (await actions).map((m: { ID: any }) => m.ID) },
            { ChildType: 'Comments and File Attachments', CanBeAdopted: false, ChildIDs: (await evidences).map((w: { ID: any }) => w.ID) }
        ];
    }

}